import React from "react";
import styles from "./DeliveryAndPaymentPage.module.css";
import PropTypes from "prop-types";

import Typography from "@material-ui/core/Typography";

function DeliveryAndPaymentPage(props) {
  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <Typography variant="h4" gutterBottom>
          CHÍNH SÁCH GIAO SẢN PHẨM TẠI KUNLEZ:
        </Typography>

        <Typography variant="body1" gutterBottom>
          <ul>
            <li>
              Giao hàng thông qua{" "}
              <a href="https://viettelpost.com.vn/en/" target="_blank">
                VETTEL POST
              </a>
              .
            </li>
          </ul>
        </Typography>
      </div>

      <div className={styles.item}>
        <Typography variant="h4" gutterBottom>
          QUY TRÌNH MUA SẢN PHẨM TẠI KUNLEZ:
        </Typography>

        <Typography variant="body1" gutterBottom>
          <ul>
            <li>
              B1: Bạn đặt hàng qua <a href="https://kunlez.web.app/">KUNLEZ</a>
            </li>
            <li>B2: Nhân viên Joca tư vấn và xác nhận đơn hàng</li>
            <li>
              B3: Thanh toán có 2 hình thức:
              <ul>
                <li>Giao hàng COD(Giao hàng thu tiền)</li>
                <li>
                  Chuyển khoản qua STK của KUNLEZ Và nhân viên giao hàng giao
                  cho bạn.
                </li>
              </ul>
            </li>
            <li>B4: Bạn nhận hàng kiểm tra hàng.</li>
          </ul>
        </Typography>
        <Typography variant="h6" gutterBottom>
          Chú ý:
        </Typography>

        <Typography variant="body1" gutterBottom>
          <ul>
            <li>
              Khách hàng vui lòng ghi rõ đầy đủ thông tin người nhận (Họ và Tên
              + Địa Chỉ + Số Điện Thoại)
            </li>
            <li>
              Khách hàng chuyển khoản vui lòng ghi nội dung là số điện thoại của
              mình
            </li>
          </ul>
        </Typography>
      </div>
    </div>
  );
}

DeliveryAndPaymentPage.propTypes = {};

export default DeliveryAndPaymentPage;
